import React from "react"
import { useRouteLoaderData} from "react-router-dom"
import { MobilePage } from "../MobilePage"

export const Content = ((props:any)=>{
    const rootLoaderData:any = useRouteLoaderData('root')
    return  <MobilePage {...props} platform={rootLoaderData.platform}/> 
})